import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  PageContainer,
  ContentGrid,
  CardContent,
  Button,
  SearchInput,
  AgentCard,
  AgentHeader,
  AgentAvatar,
  AgentInfo,
  AgentName,
  AgentType,
  StatusBadge,
  fadeIn,
  staggerContainer
} from '../styles/PageStyles';
import { faUsersRectangle } from '@fortawesome/free-solid-svg-icons';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import { getPersonas } from '../services/personaService';
import { useNavigate } from 'react-router-dom';
import EmptyStatePage from '../components/common/EmptyStatePage';

const Personas = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [personas, setPersonas] = useState([]);
  useEffect(() => {
    const fetchPersonaById = async () => {
      try {
        const response = await getPersonas();
        setPersonas(response);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchPersonaById();
  }, []);
  // Mock data for personas
  // const personas = [
  //   {
  //     id: 'PER-001',
  //     name: 'Claims Analyst',
  //     icon: '🏥',
  //     description: 'Specialized in analyzing and processing insurance claims with expertise in medical terminology and billing codes.',
  //     skills: ['Medical Coding', 'Policy Interpretation', 'Fraud Detection'],
  //     accuracy: 94,
  //     speed: 89,
  //     satisfaction: 92,
  //     status: 'active'
  //   },
  //   {
  //     id: 'PER-002',
  //     name: 'Underwriter Assistant',
  //     icon: '📝',
  //     description: 'Assists in risk assessment and policy pricing with deep knowledge of actuarial principles and risk factors.',
  //     skills: ['Risk Assessment', 'Data Analysis', 'Policy Pricing'],
  //     accuracy: 96,
  //     speed: 85,
  //     satisfaction: 90,
  //     status: 'active'
  //   },
  //   {
  //     id: 'PER-003',
  //     name: 'Customer Service Specialist',
  //     icon: '👤',
  //     description: 'Handles customer inquiries and provides policy information with a focus on clear communication and empathy.',
  //     skills: ['Communication', 'Problem Solving', 'Policy Knowledge'],
  //     accuracy: 91,
  //     speed: 94,
  //     satisfaction: 96,
  //     status: 'active'
  //   },
  //   {
  //     id: 'PER-004',
  //     name: 'Fraud Investigator',
  //     icon: '🔍',
  //     description: 'Specialized in detecting fraudulent patterns and investigating suspicious claims with forensic analysis skills.',
  //     skills: ['Pattern Recognition', 'Forensic Analysis', 'Investigation'],
  //     accuracy: 97,
  //     speed: 82,
  //     satisfaction: 88,
  //     status: 'active'
  //   },
  //   {
  //     id: 'PER-005',
  //     name: 'Document Processor',
  //     icon: '📄',
  //     description: 'Extracts and organizes information from various document types with high accuracy and attention to detail.',
  //     skills: ['OCR', 'Data Extraction', 'Document Classification'],
  //     accuracy: 95,
  //     speed: 97,
  //     satisfaction: 89,
  //     status: 'active'
  //   },
  //   {
  //     id: 'PER-006',
  //     name: 'Medical Advisor',
  //     icon: '⚕️',
  //     description: 'Provides medical expertise for complex health insurance claims and medical necessity determinations.',
  //     skills: ['Medical Knowledge', 'Treatment Evaluation', 'Clinical Guidelines'],
  //     accuracy: 98,
  //     speed: 80,
  //     satisfaction: 93,
  //     status: 'development'
  //   },
  // ];
  
  const handleNavigate = (entity) => {
    navigate(`/personas-details/${entity}`);
  };

  // Filter personas based on search term
  const filteredPersonas = personas.filter(persona =>
    persona.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    persona.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    persona.skills.some(skill => skill.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const DEFAULT_ICON = '/assets/images/agents/shield.png';

const getSafeIcon = (icon) => {
  if (typeof icon !== 'string') {
    return DEFAULT_ICON;
  }
  const iconsPaths = []

  if (
    icon.startsWith('/assets/images/agents/') &&
    iconsPaths.includes(icon)
  ) {
    return icon;
  }

  return DEFAULT_ICON;
};

  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >


        <PageHeaderWithInfo
          icon={faUsersRectangle}
          title="Personas"
          description="Design and manage specialized AI personas that can be assigned to different tasks and workflows. 
          Each persona has unique skills, knowledge bases, and behavioral characteristics tailored for specific roles."
        >
          <div style={{ display: 'flex', gap: '1rem' }}>
            <SearchInput
              type="text"
              placeholder="Search personas by name, description, or skills..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <Button >Report Suspicious Activity</Button>
            <Button primary onClick={() => handleNavigate('new')}>Create Persona</Button>
          </div>
        </PageHeaderWithInfo>

        {/* <ActionBar>
          <SearchInput
            type="text"
            placeholder="Search personas by name, description, or skills..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button>Filter</Button>
          <Button>Sort</Button>
        </ActionBar> */}

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
        >
          {filteredPersonas.length === 0 ? (
            // <div style={{
            //   textAlign: 'center',
            //   padding: '3rem',
            //   backgroundColor: 'white',
            //   borderRadius: '8px',
            //   boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            //   margin: '2rem 0'
            // }}>
            //   <img 
            //     src="/assets/images/no-results.svg" 
            //     alt="No personas found" 
            //     style={{
            //       width: '150px',
            //       height: 'auto',
            //       marginBottom: '1.5rem',
            //       opacity: '0.7'
            //     }}
            //     onError={(e) => {
            //       e.target.onerror = null;
            //       e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiNGMEYwRjAiLz48Y2lyY2xlIGN4PSIxMDAiIGN5PSI3MCIgcj0iNDAiIGZpbGw9IiNEMEQwRDAiLz48cmVjdCB4PSI0MCIgeT0iMTIwIiB3aWR0aD0iMTIwIiBoZWlnaHQ9IjQwIiByeD0iOCIgZmlsbD0iI0QwRDBEMCIvPjwvc3ZnPg==";
            //     }}
            //   />
            //   <h3 style={{ fontSize: '1.5rem', color: 'var(--text-primary)', marginBottom: '0.75rem' }}>
            //     No Personas Found
            //   </h3>
            //   <p style={{ color: 'var(--text-secondary)', maxWidth: '400px', margin: '0 auto' }}>
            //     We couldn't find any personas matching your search criteria. 
            //     Try adjusting your search terms or create a new persona.
            //   </p>
            // </div>
                 <EmptyStatePage
                    title="No personas found"
                    subtitle="We couldn't find any personas matching your search criteria. 
                Try adjusting your search terms or create a new persona."
                    icon="data"
                    primaryAction={{
                      label: 'Go Back',
                      onClick: () => {}
                    }}
                    secondaryAction={{
                      label: 'Go Home',
                      // onClick: openTemplates
                    }}
                  />
          ) : (
            <ContentGrid>
              {filteredPersonas.map((persona) => (
                <AgentCard onClick={() => handleNavigate(persona.code)}
                  key={persona.id}
                  variants={fadeIn}
                  whileHover={{ y: -5, boxShadow: '0 10px 20px rgba(0, 102, 255, 0.1)' }}
                  transition={{ duration: 0.2 }}
                >
                <AgentHeader >
                    <AgentAvatar>
                      <img src={getSafeIcon(persona?.avatar)} alt={`${persona.name} avatar`} style={{ width: "25px", height: "25px" }} />
                    </AgentAvatar>
                    <AgentInfo>
                    <AgentName>{persona.name}</AgentName>
                    <AgentType>
                      <StatusBadge status={persona.status === 'ACTIVE' ? 'active' : 'warning'}>
                        {persona.status === 'ACTIVE' ? 'Active' : 'In Development'}
                      </StatusBadge>
                    </AgentType>
                  </AgentInfo>
                </AgentHeader>

                <CardContent style={{ margin: '1rem 0' }}>
                  <p style={{ fontSize: '0.9rem', marginBottom: '1rem' }}>{persona.description}</p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem' }}>
                    {persona.skills.map((skill, index) => (
                      <span
                        key={index}
                        style={{
                          background: 'rgba(0, 102, 255, 0.1)',
                          color: 'var(--primary)',
                          padding: '0.3rem 0.6rem',
                          borderRadius: '20px',
                          fontSize: '0.8rem'
                        }}
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </CardContent>

                {/* <AgentMetrics>
                  <AgentMetric>
                    <MetricValue>{persona.accuracy}%</MetricValue>
                    <MetricLabel>Accuracy</MetricLabel>
                  </AgentMetric>
                  <AgentMetric>
                    <MetricValue>{persona.speed}%</MetricValue>
                    <MetricLabel>Speed</MetricLabel>
                  </AgentMetric>
                  <AgentMetric>
                    <MetricValue>{persona.satisfaction}%</MetricValue>
                    <MetricLabel>Satisfaction</MetricLabel>
                  </AgentMetric>
                </AgentMetrics> */}
              </AgentCard>
            ))}
          </ContentGrid>
          )}
        </motion.div>

        {/* <Card style={{ marginTop: '2rem' }}>
          <CardTitle>Persona Development Process</CardTitle>
          <CardContent>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  fontSize: '1.5rem'
                }}>
                  1
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Define Role</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Identify specific job functions and responsibilities</p>
              </div>

              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  fontSize: '1.5rem'
                }}>
                  2
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Train Model</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Fine-tune AI with domain-specific knowledge</p>
              </div>

              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  fontSize: '1.5rem'
                }}>
                  3
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Test & Refine</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Validate performance in simulated scenarios</p>
              </div>

              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem auto',
                  fontSize: '1.5rem'
                }}>
                  4
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Deploy</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Integrate persona into production workflows</p>
              </div>
            </div>
          </CardContent>
        </Card> */}
      </motion.div>
    </PageContainer>
  );
};

export default Personas;
